import Inline from 'quill/blots/inline';

// Source: https://github.com/quilljs/quill/compare/jc-color
// Fix browser default behavior for adding <font> elements

class CodeEmbedFont extends Inline {
  static blotName = 'code-embed-font';
  static tagName = 'FONT';

  optimize(context: { [key: string]: unknown }) {
    super.optimize(context);
    return this.replaceWith(Inline.blotName);
  }
}

export default CodeEmbedFont;
